import { env } from '@/env';
import { adminClient, customSessionClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import type { auth } from './auth';

// NOTE: oneTapClient was removed to eliminate console errors ("Not signed in with
// the identity provider.") that were causing Best Practices score failures in
// Lighthouse audits. The one-tap Google Sign-In was causing repeated errors
// when no Google session was available, which polluted the browser console.
// The regular sign-in buttons remain fully functional.
export const authClient = createAuthClient({
  baseURL: typeof window !== 'undefined' ? window.location.origin : env.NEXT_PUBLIC_APP_URL,
  plugins: [
    adminClient(),
    customSessionClient<typeof auth>(),
  ],
});
